import { useEffect, useState } from "react";
import "./MenuScreen.css";

export type MapSelection =
  | "poland"
  | "europe"
  | "world"
  | "north-america"
  | "south-america"
  | "africa"
  | "oceania"
  | "asia";

interface MenuScreenProps {
  onSelect: (map: MapSelection) => void;
  onBack?: () => void;
}

export function MenuScreen({ onSelect, onBack }: MenuScreenProps) {
  const [hideWorld, setHideWorld] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px), (pointer: coarse)");
    const update = () => setHideWorld(media.matches);
    update();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", update);
      return () => media.removeEventListener("change", update);
    }
    media.addListener(update);
    return () => media.removeListener(update);
  }, []);

  return (
    <div className="MenuScreen">
      <div className="MenuCard">
        {onBack && (
          <button className="MenuBack" type="button" onClick={onBack}>
            Wstecz
          </button>
        )}
        <div className="MenuTitle">Geo Quiz</div>
        <div className="MenuSubtitle">Wybierz mapę, aby rozpocząć</div>
        <div className="MenuActions">
          <button
            className="MenuButton"
            type="button"
            onClick={() => onSelect("poland")}
          >
            Polska — województwa
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("europe")}
          >
            Europa — państwa
          </button>
          {!hideWorld && (
            <button
              className="MenuButton is-secondary"
              type="button"
              onClick={() => onSelect("world")}
            >
              Świat — duże państwa
            </button>
          )}
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("north-america")}
          >
            Ameryka Północna — państwa
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("south-america")}
          >
            Ameryka Południowa — państwa
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("africa")}
          >
            Afryka — państwa
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("oceania")}
          >
            Oceania — państwa
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={() => onSelect("asia")}
          >
            Azja — państwa
          </button>
        </div>
      </div>
      <div className="MenuBackdrop" />
    </div>
  );
}
